//
//
//
//
//
//
//
//
//
//
//
//
//

import '@/plugins/ant-design-public.js'
import { IGNORE_ROUTES } from "@/constants/analitics.js";

export default {
  name: 'ArtSpecialProject',

  head() {
    if (process.env.isStaging || IGNORE_ROUTES.includes(this.$route.name)) {
      return {
        link: [
          {
            rel: 'canonical',
            href: this.headCanonicalUrl
          }
        ]
      }
    }

    return {
      link: [
        {
          rel: 'canonical',
          href: this.headCanonicalUrl
        }
      ]
    }
  },

  computed: {
    headCanonicalUrl() {
      const url = this.$addServerPath('/');
      let canonicalUrl = url.split('/').slice(0, 3).join('/') + this.$route.path
      if (canonicalUrl[canonicalUrl.length - 1] === '/') {
        canonicalUrl = canonicalUrl.slice(0, canonicalUrl.length - 1);
      }
      return canonicalUrl
    }
  },
}
